import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Badge from 'react-bootstrap/Badge';
import Image from 'react-bootstrap/Image';
import placeholder from '../assets/images/placeholder.png';
import { StyledMember, StyledPanel, StyledItem } from '../stylesheets/styles';
import { API_URL, API_IMAGE_URL } from '../common/constants';
import BgComponent from '../components/BgComponent';
import { isEmpty } from 'lodash';
import classNames from 'classnames';
import AuthContext from '../contexts/AuthContext';
import ModalContext from '../contexts/ModalContext';

const Item = ({ note }) => {
  const {id, subject, content, publishDate, thumbnail, isRead } = note;
  const thumbnail_url = `${API_IMAGE_URL}${thumbnail}`;
  if (isEmpty(note)) { return null; }

  return (
    <StyledItem className='item-wrap notice-item'>
      <Link className='item-link' to={`/notice/${id}`}>
        <div className={classNames('item', isRead ? 'read' : 'unread')}>
          <div className='item-img'>
            <Image src={thumbnail ? thumbnail_url : placeholder} />
          </div>
          <div className='item-content'>
            <Badge className='subject' bg="primary">{subject}</Badge>
            <div className="content static-content ck-content" style={{ filter: "grayscale(1) brightness(0)" }} dangerouslySetInnerHTML={{ __html: content }} />
            <p className='item-date d-block d-md-none ps-0 text-left'>{new Date(publishDate).toLocaleDateString()}</p>
          </div>
          <p className='item-date d-none d-md-block'>{new Date(publishDate).toLocaleDateString()}</p>
        </div>
      </Link>
    </StyledItem>
  );
}

const Notices = (props) => {
  const [notice, setNotice] = useState([]);
  const { isAuth } = useContext(AuthContext);
  const { handleShow } = useContext(ModalContext);

  useEffect(() => {
    const fetchNotice = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          console.error('No token found');
          handleShow();
          return;
        }
        const response = await axios.get(`${API_URL}/api/notice`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        if (response.status === 401 || response.status === 500) {
          handleShow();
          return;
        }
  
        if (response.data.isSuccess) {
          setNotice(response.data.result);
        }
      } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 500)) {
          handleShow();
        } else {
          console.error('Error fetching notice:', error);
        }
      }
    };

    if (isAuth){
      fetchNotice()
    };
    
  }, [isAuth]);

  return (
    <StyledMember className='notice'>
      <div className='member-wrap notice-wrap'>
        <Container>
          <Row className="justify-content-md-center">
            <Col xl="7" lg="10" md="12">
              <StyledPanel className='content-panel'>
                <div className="hgroup">
                  <h1 className="text-center">用戶通知</h1>
                </div>
                <section className='section'>
                  <StyledItem className='item-wrap item-header d-none d-md-flex'>
                    <div className='item-img'>
                      內容
                    </div>
                    <div className='item-date'>時間</div>
                  </StyledItem>
                  {notice.map(note => (
                    <Item key={note.id} note={note} />
                  ))}
                </section>
              </StyledPanel>
            </Col>
          </Row>
        </Container>
        <BgComponent/>
      </div>
    </StyledMember>
  );
};

export default Notices;
